<template>
  <div>
  <v-toolbar flat color="white">
    <v-toolbar-title>Alumno</v-toolbar-title>
    <v-divider
      class="mx-2"
      inset
      vertical
    ></v-divider>
    <v-spacer></v-spacer>
    <!-- <v-btn color="primary" dark class="mb-2" v-on:click="nuevoRegistro()">Ingresar cierre de caja</v-btn> -->
  </v-toolbar>
  <v-data-table
    :headers="headers"
    :items="datos.data"
    :pagination.sync="pagination"
    :total-items="totalRegistros"
    :loading="loading"
    rows-per-page-text="Filas por página"
  >
    <template slot="items" slot-scope="props">
      <td>{{ props.item.fila[1] }}</td>
      <td class="">{{ props.item.fila[2] }}</td>
      <td class="">{{ props.item.fila[3] }}</td>
      <td class="">{{ props.item.fila[4] }}</td>
      <td class="">{{ props.item.fila[5] }}</td>
      <td class="">{{ props.item.fila[6] }}</td>
      <td class="">{{ props.item.fila[8] }}</td>
      <td class="">{{ props.item.fila[9] }}</td>
      <td class="justify-center layout px-0">
        <!-- <v-icon
          v-if="props.item.fila[0] !== 0"
          small
          class="mr-2"
          @click="verRegistro(props.item)"
        >
          open_in_browser
        </v-icon> -->
      </td>
    </template>
    <template slot="no-data">
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  data: () => ({
    dialog: false,
    disabledRegistro: false,
    disabledAsesor: false,
    validarAlumno: true,
    totalRegistros: 0,
    loading: false,
    pagination: {},
    menu: false,
    cierreFecha: null,
    headers: [
      { text: 'Apellido paterno', value: 0 },
      { text: 'Apellido materno', value: 1 },
      { text: 'Nombres', value: 2 },
      { text: 'DNI', value: 3 },
      { text: 'Teléfono', value: 4 },
      { text: 'Correo', value: 5 },
      { text: 'Colegio', value: 6 },
      { text: 'Grado', value: 7 },
      { text: 'Actions', align: 'center', value: '', sortable: false }
    ],
    datos: [],
    registro: {},
    grado: '',
    asesor: []
  }),
  computed: {
    computedCierreFecha () {
      return this.formatoFecha(this.registro.cierreFecha)
    }
  },
  watch: {
    dialog (val) {
      val || this.cerrar()
    },
    'registro.cierreFecha' (val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha)
    },
    pagination: {
      handler () {
        if (this.loading === false) {
          let descendente = 0
          if (this.pagination.descending) {
            descendente = 1
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
        }
      },
      deep: true
    }
  },
  created () {
    this.initialize()
    if (this.login === false) {
      this.$router.push('/Ingresar')
    }
    this.pagination.rowsPerPage = 10
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    apiListaRegistros (idx, ord, pagina) {
      var solicitudApi = this.crearSolicitud()
      if (this.datos.pagina === undefined) {
        pagina = 0
      }
      this.loading = true
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina,
        grado: ''
      }
      solicitudApi.datos = datos
      const myRequest = new Request(`${process.env.API}inicio.php?mod=ficha&accion=listar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.datos = datos.d
            this.totalRegistros = this.datos.registros
            if (parseInt(this.datos.pagina) !== parseInt(this.pagination.page)) {
              this.pagination.page = parseInt(this.datos.pagina)
            }
            this.loading = false
          }
        })
    },
    setTotal: function (total) {
      this.registro.comprobanteTotal = total
    },
    registrarAlumo () {
      var solicitudApi = this.crearSolicitud()
      this.registro.grado = this.grado
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.API}inicio.php?mod=ficha&accion=guardar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.e === 1) {
            this.registro = {
              apellidoPaterno: '',
              apellidoMaterno: '',
              nombres: '',
              dni: '',
              telefono: '',
              correo: ''
            }
            let descendente = 0
            if (this.pagination.descending) {
              descendente = 1
            }
            this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
          } else {
            alert(datos.m)
          }
        })
    },
    verRegistro (item) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = []
      const myRequest = new Request(`${process.env.API}ventas/cierre/ver/id/` + item.fila[0], {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.registro = datos.d
            this.productosDetalle = {}
            if (item.fila[0] !== 0) {
              this.disabledRegistro = true
            } else {
              this.disabledRegistro = false
            }
            this.dialog = true
          }
        })
    },
    nuevoRegistro () {
      this.verRegistro({fila: [0]})
    },
    cerrar () {
      this.dialog = false
      setTimeout(() => {
      }, 300)
    },
    guardar () {
      this.cerrar()
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.API}ventas/cierre/agregar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.verRegistro({fila: [datos.d.id]})
              let descendente = 0
              if (this.pagination.descending) {
                descendente = 1
              }
              this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
            }
          }
        })
    },
    verAlumnos (grado) {
      this.grado = grado
    },
    imprimirCredencial () {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {datos: this.datos.data}
      const myRequest = new Request(`${process.env.API}credencial.php`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.blob())
        .then(fileBlob => {
          var newBlob = new Blob([fileBlob], {type: 'application/pdf'})
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
          }
          const data = window.URL.createObjectURL(newBlob)
          var link = document.createElement('a')
          link.href = data
          link.target = '_blank'
          link.click()
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Ficha.vue